"use client";

const Previews = () => {
  const blurClass = "backdrop-blur-[2px]";
  const overlayClass = "bg-black/10";
  return (
    <section className="relative z-0 bg-deepSlate dark:bg-darkmode py-14 sm:py-20 overflow-hidden">
      {" "}
      <div className="container mx-auto max-w-7xl px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-black dark:text-white">
            Explore 3D Preview Examples
          </h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {/* COLUMN-1 */}
          <div className="relative overflow-hidden bg-primary/10 pt-10 sm:pt-12 px-6 sm:px-10 lg:px-16 pb-12 sm:pb-16 rounded-3xl bg-[url('/images/previews/can-preview-bg.png')] bg-no-repeat bg-cover min-h-[420px] sm:min-h-[520px] lg:min-h-[600px]">
            <div className={`absolute inset-0 ${blurClass} ${overlayClass}`} />
            <div className="relative z-10">
              <p className="text-sm sm:text-base lg:text-lg font-normal text-primary tracking-widest mb-4 sm:mb-5 text-center sm:text-start uppercase">
                3D CAN PREVIEW
              </p>
              <h3 className="text-xl sm:text-2xl md:text-3xl text-black mb-4 sm:mb-5 text-center sm:text-start">
                Classic 250ml Can{" "}
                <span className="text-black/60">in realistic 3D.</span>
              </h3>
              <p className="text-sm sm:text-base lg:text-lg text-black/75 pt-2 mb-8 sm:mb-10 text-center sm:text-start">
                Explore lighting, reflections, and label fit on a high‑fidelity
                can render.
              </p>
              <div className="text-center sm:text-start mt-4 sm:mt-6">
                <a
                  href="https://previewer.atlasimex.es/shared/a09977a1-53a1-48ef-b55e-8ca7482a16fc"
                  target="_blank"
                  rel="noreferrer"
                  className="text-xl py-4 px-10 mt-5 font-semibold text-white rounded-full bg-primary border border-primary hover:bg-primary/90 hover:border-primary/90"
                >
                  View 3D Preview
                </a>
              </div>
            </div>
          </div>

          {/* COLUMN-2 */}
          <div className="">
            <div className="relative overflow-hidden bg-slate-100 pt-10 sm:pt-12 px-6 sm:px-10 lg:px-16 pb-12 sm:pb-16 rounded-3xl bg-[url('/images/previews/traybox-preview-bg.png')] bg-no-repeat bg-cover min-h-[420px] sm:min-h-[520px] lg:min-h-[600px]">
              <div
                className={`absolute inset-0 ${blurClass} ${overlayClass}`}
              />
              <div className="relative z-10">
                <p className="text-sm sm:text-base lg:text-lg font-normal text-primary tracking-widest mb-4 sm:mb-5 text-center sm:text-start uppercase">
                  3D TRAY BOX PREVIEW
                </p>
                <h3 className="text-xl sm:text-2xl md:text-3xl text-black mb-4 sm:mb-5 text-center sm:text-start">
                  24‑Tray Box{" "}
                  <span className="text-black/60">with wrap details.</span>
                </h3>
                <p className="text-sm sm:text-base lg:text-lg text-black/75 pt-2 mb-8 sm:mb-10 text-center sm:text-start">
                  Review packaging scale and label alignment on the tray box
                  model.
                </p>
                <div className="text-center sm:text-start mt-4 sm:mt-6">
                  <a
                    href="https://previewer.atlasimex.es/shared/0abf4a18-f204-428f-bba9-6c674e3e7af2"
                    target="_blank"
                    rel="noreferrer"
                    className="text-xl py-4 px-10 mt-5 font-semibold text-white rounded-full bg-primary border border-primary hover:bg-primary/90 hover:border-primary/90"
                  >
                    View 3D Preview
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Previews;
